import * as Yup from "yup";

export const bioGraphyVideValidation = Yup.object().shape({
  value: Yup.string().required("وارد کردن آدرس ویدئو الزامی است"),
});
